<!--
 * 适用于首页每个模块的顶部
 * creat by cgz at 2020年3月31日20:02:24
-->
<template>

  <div class="rootContainer">

    <div class="cell-center">{{title}}</div>
    <div class="cell-right" @click="BTActionRightArrow">
      <div>更多</div>
      <van-icon class="arrowRight" name="arrow" />
    </div>
  </div>

</template>


<script>
export default {
  name: "panelHeader",
  props: {
    title: {
      type: String,
      default: "标题"
    },
    tag: {
      default: "undefined pannel header tag" //1:优惠券 2:品牌制造商直供 3:周一周四 新品首发 4:人气推荐 5:专题精选 6:时令水果 7:热带水果 8:瓜类 9:柑橘橙柚
    }
  },
  methods: {
    BTActionRightArrow() {
      this.$emit("click", this.tag.toString());
    }
  }
};
</script>


<style scoped lang="scss">
.rootContainer {
  height: 5rem;
  background-color: white;
  box-sizing: border-box;
  padding: 0 0.9rem 0 1.6rem;
  display: flex;
  justify-content: space-between;

  .cell-center {
    font-family: PingFangSC-Semibold;
    font-size: 1.6rem;
    color: #424242;
    letter-spacing: 0;
    line-height: 5rem;
  }

  .cell-right {
    opacity: 0.5;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    letter-spacing: 0;
    text-align: right;
    line-height: 5rem;
    display: flex;
    flex-direction: row;
  }
  .arrowRight {
    font-size: 1.4rem;
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/panelHeader.vue